import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Dress from "./views/Dress.vue";
import Events from "./views/Events.vue";
//crud
import Create from "./views/crud/Create.vue";
import Update from "./views/crud/Update.vue";
import List from "./views/crud/List.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/dress/:id",
      name: "dress",
      component: Dress
    },
    {
      path: "/calendar",
      name: "calendar",
      component: Events
    },
    {
      path: "/model/:model",
      component: List
    },
    {
      path: "/model/:model/new",
      component: Create
    },
    {
      path: "/model/:model/:id",
      component: Update
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    }
  ]
});
